import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { getTranslation } from "../locales";

interface SurveyClosedPageProps {
  locale?: string;
  customTitle?: string | null;
  customSubtitle?: string | null;
  customMessage?: string | null;
}

const SurveyClosedPage: React.FC<SurveyClosedPageProps> = ({
  locale = "en",
  customTitle,
  customSubtitle,
  customMessage,
}) => {
  const theme = useTheme();
  const t = getTranslation(locale);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "40px",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f8f9fa",
          padding: "60px",
          borderRadius: "12px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          maxWidth: "700px",
          width: "100%",
        }}
      >
        {customTitle && (
          <Typography
            variant="h2"
            sx={{
              color: theme.palette.primary.main,
              marginBottom: "30px",
              fontSize: "3rem",
              fontWeight: "bold",
            }}
          >
            {customTitle}
          </Typography>
        )}
        <Typography
          variant="h5"
          sx={{
            fontSize: "1.4rem",
            color: "#6c757d",
            marginBottom: customMessage ? "25px" : undefined,
            lineHeight: "1.6",
          }}
        >
          {customSubtitle || t.surveyClosed}
        </Typography>
        {customMessage && (
          <Typography
            variant="h6"
            sx={{
              fontSize: "1.2rem",
              color: "#6c757d",
              lineHeight: "1.6",
            }}
          >
            {customMessage}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SurveyClosedPage;
